module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-1000.f60a8ecb.svg";